import React, { useState } from "react";
import { Card, CardHeader, CardBody, Row, Col, Table, Button } from "reactstrap";

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import { AttendanceAdjustModal } from './AttendanceAdjustModal';

var Utils = require('Utils');

var sdf = require('date-format');

const formatQty = (qty) => {
  const n = parseFloat(qty);
  if (isNaN(n) || n === 0) return '-';
  return n.toFixed(2);
};

const getAttendanceId = (row) =>
  row.attendance_id || row.student_attendance_id || row.id;

export const AttendanceListCard = ({
  attendanceList,
  persona,
  onAddAdjustment,
  onDeleteAttendance,
  isSavingAdjustment,
  isDeletingAttendance,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  let total = 0;
  let attendanceFixed = attendanceList.map((att) => {
    const qty = parseFloat(att.qty);
    total = total + (isNaN(qty) ? 0 : qty);
    return {
      ...att,
      fmtDate: sdf.asString('dd/MM/yy', new Date(att.date)),
      fmtQty: formatQty(att.qty),
    };
  });

  attendanceFixed.push({
    description: 'Total insasistencias a la fecha',
    fmtQty: formatQty(total),
    isTotal: true,
  });

  const handleSave = (qty) => {
    if (onAddAdjustment) {
      onAddAdjustment(qty, () => setModalOpen(false));
    }
  };

  const exportPdf = () => {
    const doc = new jsPDF();
    const columnTitles = ['Fecha', 'Descripción', 'Cantidad'];
    const pdfData = attendanceFixed.map((rowData) => [
      rowData.fmtDate || '',
      rowData.description || '',
      rowData.fmtQty || '',
    ]);
    doc.text(
      'Inasistencias de '
        + Utils.capitalize(persona.last_name + ', ' + persona.name)
        + ' al '
        + sdf.asString('dd/MM/yy', new Date()),
      10,
      10,
    );

    doc.autoTable({
      head: [columnTitles],
      body: pdfData,
    });

    doc.save(
      'Borrador de inasistencias de '
        + Utils.capitalize(persona.last_name + ', ' + persona.name)
        + '.pdf',
    );
  };

  return (
    <>
      <AttendanceAdjustModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        onSave={handleSave}
        isSaving={isSavingAdjustment}
      />
      <Card>
        <CardHeader>
          <Row className="align-items-center">
            <Col className="pr-1" md="8">
              <h5 className="title mb-0">
                Inasistencias
                {onAddAdjustment && (
                  <span style={{ fontWeight: 400, fontSize: '0.875rem' }}>
                    {' '}
                    [
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setModalOpen(true);
                      }}
                    >
                      Ingresar ajuste de inasistencias
                    </a>
                    ]
                  </span>
                )}
              </h5>
            </Col>
            <Col className="ml-auto text-right" md="4">
              <a
                href="#"
                style={{ fontSize: '0.875rem' }}
                onClick={(e) => {
                  e.preventDefault();
                  exportPdf();
                }}
              >
                Exportar PDF
              </a>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <Table responsive bordered striped size="sm">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Descripción</th>
                <th style={{ textAlign: 'right' }}>Cantidad</th>
                {onDeleteAttendance && <th style={{ width: 48 }}></th>}
              </tr>
            </thead>
            <tbody>
              {attendanceFixed.map((row, idx) => {
                const attendanceId = getAttendanceId(row);
                return (
                  <tr key={attendanceId || `row-${idx}`}>
                    <td>{row.fmtDate}</td>
                    <td>{row.description}</td>
                    <td align="right">{row.fmtQty}</td>
                    {onDeleteAttendance && (
                      <td align="center">
                        {!row.isTotal && (
                          <Button
                            color="danger"
                            size="sm"
                            disabled={isDeletingAttendance || !attendanceId}
                            onClick={() => {
                              if (!attendanceId) return;
                              onDeleteAttendance({ ...row, attendance_id: attendanceId });
                            }}
                          >
                            <i className="fa fa-trash" aria-hidden="true"></i>
                          </Button>
                        )}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};
